module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_02_black-68f9315f19b697ded147dcb090999030.png";